module.exports = __webpack_public_path__ + "img/guideline_1.13d87963.jpg";